interface String {
  contains(searchString: string): boolean;
  empty(): string;
  capitalizeFirstLetter(): string;
  isUkShortDateFormat(): boolean;
  removeLeadingSlash(): string;
}

String.prototype.contains = function contains(searchString: string) {
  return this.toLowerCase().indexOf(searchString.toLowerCase()) > -1;
};

String.prototype.empty = () => '';

String.prototype.capitalizeFirstLetter = function capitalizeFirstLetter() {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

String.prototype.isUkShortDateFormat = function isUkShortDateFormat() {
  const regex = new RegExp(/^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/i);
  return regex.test(this.toString());
};

String.prototype.removeLeadingSlash = function removeLeadingSlash() {
  return this == null ? this : this[0] === '/' ? this.slice(1) : this as string;
};


